/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-frontmatter').Options} Options
 */
import { frontmatter } from 'micromark-extension-frontmatter';
import { frontmatterFromMarkdown, frontmatterToMarkdown } from 'mdast-util-frontmatter';
/**
 * Plugin to add support for frontmatter.
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */

export default function remarkFrontmatter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'yaml';
  var data = this.data();
  add('micromarkExtensions', frontmatter(options));
  add('fromMarkdownExtensions', frontmatterFromMarkdown(options));
  add('toMarkdownExtensions', frontmatterToMarkdown(options));
  /**
   * @param {string} field
   * @param {unknown} value
   */

  function add(field, value) {
    var list =
    /** @type {unknown[]} */
    // Other extensions

    /* c8 ignore next 2 */
    data[field] ? data[field] : data[field] = [];
    list.push(value);
  }
}